/**
 * Storms API Service
 *
 * API service for Hurricane Impact Prediction (HIP) storm endpoints
 */

import api from "../client";
import { ENDPOINTS } from "../endpoints";
import type {
  NamedStorm,
  StormMetadataResponse,
  TrackSnapshot,
  TrackGeoJSON,
  ImpactForecast,
  ScenarioQueryParams,
} from "../types";

export const stormsApi = {
  /**
   * List all storms (active by default).
   * Pass stormApplicationId to filter by storm_application (e.g. WIP/HIP app id).
   */
  list: (activeOnly: boolean = true, stormApplicationId?: string) =>
    api.get<NamedStorm[]>(ENDPOINTS.STORMS, {
      params: {
        active_only: activeOnly,
        ...(stormApplicationId && { storm_application_id: stormApplicationId }),
      },
    }),

  /**
   * Get metadata for a specific storm
   * Returns available weather models and slider ranges
   */
  getMetadata: (stormId: string) =>
    api.get<StormMetadataResponse>(ENDPOINTS.STORM_METADATA(stormId)),

  /**
   * Get scenario snapshot based on deviation parameters
   */
  getScenario: (stormId: string, params: ScenarioQueryParams) =>
    api.get<TrackSnapshot>(ENDPOINTS.STORM_SCENARIO(stormId), {
      params: {
        weather_model_name: params.weather_model_name,
        intensity: params.intensity,
        track: params.track,
        speed: params.speed,
      },
    }),

  /**
   * Get track GeoJSON for a specific snapshot
   */
  getTrack: (snapshotId: string) =>
    api.get<TrackGeoJSON>(ENDPOINTS.STORM_SNAPSHOT_TRACK(snapshotId)),

  /**
   * Get impact forecasts for a specific snapshot
   */
  getImpacts: (snapshotId: string) =>
    api.get<ImpactForecast[]>(ENDPOINTS.STORM_SNAPSHOT_IMPACTS(snapshotId)),
};

export default stormsApi;

